class CategoriesApi {
  static getCateg () {
    const request = new Request(`${process.env.REACT_APP_API_URL}/category`, {
      method: 'GET',
      headers: new Headers({
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + sessionStorage.getItem('token')
      })
    })

    return fetch(request)
      .then(response => response.json())
      .then(response => {
        return response
      })
      .catch(error => {
        return error
      })
  }
}

export default CategoriesApi



// WEBPACK FOOTER //
// ./src/api/CategoriesApi.js